<template>
  <nav class="bottom-nav">
    <router-link 
      v-for="item in navItems" 
      :key="item.route"
      :to="item.route" 
      class="nav-item"
      :class="{ active: isActive(item.route) }"
    >
      <i :class="item.icon"></i>
      <span>{{ item.label }}</span>
      <span v-if="item.badge && item.badge > 0" class="nav-badge">
        {{ item.badge }}
      </span>
    </router-link>
  </nav>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useCartStore } from '@/stores/cart'

const route = useRoute()
const cartStore = useCartStore()

const navItems = computed(() => [
  {
    route: '/menu',
    icon: 'bi bi-grid-3x3-gap',
    label: 'Меню'
  },
  {
    route: '/cart',
    icon: 'bi bi-cart',
    label: 'Корзина',
    badge: cartStore.itemCount
  },
  {
    route: '/orders',
    icon: 'bi bi-box-seam',
    label: 'Заказы'
  }
])

const isActive = (routePath) => {
  if (routePath === '/menu') {
    return route.path === '/' || route.path === '/menu'
  }
  return route.path.startsWith(routePath)
}
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  min-height: calc(68px + env(safe-area-inset-bottom));
  background: rgba(255, 255, 255, 0.95);
  border-top: 1px solid var(--border);
  padding: 6px max(8px, env(safe-area-inset-right)) env(safe-area-inset-bottom) max(8px, env(safe-area-inset-left));
  z-index: 1000;
  box-shadow: 0 -10px 30px rgba(38, 29, 22, 0.07);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  min-width: 64px;
  min-height: 54px;
  padding: 7px 10px 5px;
  border-radius: 16px;
  text-decoration: none;
  color: var(--text-muted, #666666);
  font-size: 11px;
  font-weight: 650;
  position: relative;
  transition: color 0.16s cubic-bezier(0.16, 1, 0.3, 1),
              background 0.16s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.12s cubic-bezier(0.16, 1, 0.3, 1);
  user-select: none;
}

.nav-item:active {
  transform: scale(0.92);
}

.nav-item i {
  font-size: 21px;
  line-height: 1;
  transition: transform 0.16s cubic-bezier(0.16, 1, 0.3, 1);
}

.nav-item.active i {
  transform: scale(1.06);
}

.nav-item.active {
  color: var(--primary-strong);
  background: var(--primary-soft);
}

.nav-badge {
  position: absolute;
  top: 2px;
  right: 4px;
  background: var(--primary);
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 700;
  min-width: 19px;
  text-align: center;
  border: 2px solid white;
  animation: badgeBump 0.28s cubic-bezier(0.16, 1, 0.3, 1);
  font-variant-numeric: tabular-nums;
  font-feature-settings: 'tnum';
}

@media (max-width: 359px) {
  .nav-item {
    min-width: 56px;
    padding-inline: 6px;
  }
}
</style>
